import React from 'react';
import Pro01 from "../../images/services/cto/Tech-Leaders-banner.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Tech Leaders">
                            <h2>Seasoned Tech Leaders</h2>
                        </div>
                        <p>While we love creating impact with emerging technologies, we understand that it’s not the
                            easiest for most startups. While capital and funds can challenge many startups, others can’t
                            leap because of a lack of strategic leadership. Check TekRevol’s work in numbers and
                            overcome business challenges with our advisory services.
                        </p>
                        <p>Additionally, regulatory barriers and market saturation can also hinder the growth of
                            startups in emerging technology sectors. Moreover, attracting and retaining top talent in a
                            competitive job market can be a significant challenge for startups seeking to innovate with
                            emerging technologies.</p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">55+<span>Applications Delivered</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">34+<span>Businesses Transformed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">11+<span>Industries Served</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;